// extracted by mini-css-extract-plugin
export default {"quadroLink":"QuadroLink_quadroLink__AVNIM","bgRosaClaro":"QuadroLink_bgRosaClaro__D7AHf","bgRosaEscuro":"QuadroLink_bgRosaEscuro__cFh-w","bgVerde":"QuadroLink_bgVerde__agLoY"};